import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { RoleList, RoleListAPI } from '../models/role';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  constructor() {}

  pullList(): Observable<RoleList> {
    const headers = this.getHeaders();

    var params: HttpParams = new HttpParams();

    return this.http
      .get<RoleListAPI>(`${environment.api.gateway}role`, {
        headers,
        params: params,
      })
      .pipe(map((roleListAPI: RoleListAPI) => RoleList.factory(roleListAPI)));
  }
}
